export const eventSignificanceOptions = [
  { name: "Milestone/Era Changing", value: 50, icon: "fas fa-diamond fa-fw" }, //square filled lg
  { name: "Major/Global", value: 40, icon: "far fa-square fa-fw" }, //circle filled lg
  { name: "Important/National", value: 30, icon: "fas fa-circle fa-fw" }, //circle outline lg
  { name: "Minor/Regional", value: 20, icon: "far fa-square fa-fw" }, //circle outline sm
  { name: "Trivial/Personal", value: 10, icon: "far fa-circle fa-fw" }, //circle outline sm
  { name: "No Significance", value: null, icon: "far fa-circle fa-fw" }, //circle outline sm
];
